import { useTranslation } from 'next-i18next';

import { IconButton } from 'components';
import { CVUploadModalInstance } from 'components/candidate/CVUploadModal';
import { ButtonV3 } from 'components/ComponentV2';

import styles from './CVUploadBanner.module.scss';

export const CVUploadBanner = ({ onClose }: { onClose: () => void }) => {
  const [t] = useTranslation('candidate.profile');

  const handleCVUpload = async () => {
    try {
      await CVUploadModalInstance();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <article className={styles.container}>
      <section className={styles['emoji-container']}>
        <p className={styles['waving-hand']}>👋</p>
      </section>
      <section className={styles.text}>
        <p className={styles.line1}>{t('cv-upload-banner.title')}</p>
        <p className={styles.line2}>{t('cv-upload-banner.description')}</p>
      </section>
      <section className={styles['action-btns']}>
        <ButtonV3 onClick={handleCVUpload} className={styles.cta}>
          {t('cv-upload-banner.button-text')}
        </ButtonV3>
        <IconButton
          className={styles['close-large']}
          iconName="icon_close"
          size="small"
          onClick={onClose}
        />
      </section>
      <IconButton
        className={styles['close-small']}
        iconName="icon_close"
        size="small"
        onClick={onClose}
      />
    </article>
  );
};
